<template>
  <v-container>
    <section class="mt-2 mb-10">
      <h1 v-if="me" class="font-size--24">
        {{ me.name }} 사장님!<br />내일 매출을 미리 받아보세요!
      </h1>
    </section>
    <GetOffer
      :loading.sync="getOfferLoading"
      :offer.sync="offer"
      :options="componentGetOffer.options"
    >
      <div></div>
    </GetOffer>

    <section class="mb-10">
      <p class="font-size--18 color--nice-grey font-weight-bold mb-0">미리 받을 수 있는 매출은</p>
      <h1 class="font-size--35 font-weight-black">
        <v-layout :justify-center="!offer || offer.amount === 0">
          <v-fade-transition hide-on-leave>
            <!-- 오퍼 없거나 상태가 미완료일때 -->
            <v-progress-circular
              v-if="isOfferInProgress"
              size="36"
              class="my-2"
              color="grey"
              indeterminate
            />

            <!-- 가능 금액 없을 때 -->
            <span v-else-if="offer && offer.amount === 0"> - 원 </span>

            <!-- 한도 산출 완료 -->
            <span v-else> {{ commaFormat(offer.amount) }} 원 </span>
          </v-fade-transition>
        </v-layout>
      </h1>
      <p class="color--nice-grey mb-0">금리 일 0.03% / 수수료 0.2%(단건)</p>
    </section>

    <section class="mb-4">
      <!-- 오퍼의 상태가 미완료일때 -->
      <BasicButton v-if="isOfferInProgress" depressed height="48" disabled>
        한도 산출 중
      </BasicButton>

      <!-- 한도 산출 완료 -->
      <BasicButton
        v-else
        depressed
        height="48"
        :disabled="!isLoanRequestable || requestLoanLoading"
        :loading="requestLoanLoading"
        @click="request"
      >
        {{ isLoanRequestable ? '내일 매출 당겨받기' : `신청 시간 ${startHour}시 ~ ${endHour}시` }}
      </BasicButton>
    </section>

    <section>
      <ul class="font-size--14 color--nice-grey outer">
        <li>내일매출 당겨받기는 P2P 방식으로 온라인 모집하여 지급합니다.</li>
        <li>모집 기간은 1일이며, 신청하신 금액 중 일부만 모집-지급될 수 있습니다.</li>
      </ul>
    </section>

    <v-footer fixed>
      <v-layout justify-center>
        <v-btn
          text
          color="grey"
          height="25"
          :disabled="requestLoanLoading"
          style="text-decoration: underline"
          :to="{ name: 'earlypay' }"
        >
          정산내역으로 돌아가기
        </v-btn>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { commaFormat } from '@/filter/number'
import { sleep } from '@/util'

export default {
  data() {
    return {
      componentGetOffer: {
        options: {
          repayment_period_in_days: 30,
          loan_type: 'normal',
        },
      },
      offer: null,
      requestLoanLoading: false,
      getOfferLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('loan', ['loanAvailableTime']),
    ...mapGetters('loan', [
      'isPullRevenueOfferRequest',
      'isLoanAvailableTime',
      'investingPullRevenue',
    ]),
    ...mapGetters('evaluation', ['isExpire']),
    startHour() {
      const result = this.loanAvailableTime
        ? Number(this.loanAvailableTime.startHour.split(':')[0])
        : ''
      const hour = 12
      return result > hour ? `오후 ${result - hour}` : `오전 ${result}`
    },
    endHour() {
      const result = this.loanAvailableTime
        ? Number(this.loanAvailableTime.endHour.split(':')[0])
        : ''
      const hour = 12
      return result > hour ? `오후 ${result - hour}` : `오전 ${result}`
    },
    isLoanRequestable() {
      return (
        this.isLoanAvailableTime &&
        this.isPullRevenueOfferRequest &&
        this.offer &&
        this.offer.amount >= 100000
      )
    },
    isOfferInProgress() {
      if (!this.offer) return true
      return this.offer.status === 'in_progress'
    },
  },
  async created() {
    _meta({
      titles: ['당겨받기'],
    })
    const { requestProcess } = this.$route.query
    if ([true, 'true'].includes(requestProcess)) {
      await this.request()
    }
    await this.getLoanAvailableTime()
  },
  methods: {
    commaFormat,
    ...mapActions('loan', [
      'addLoansOffersCurrent',
      'createLoan',
      'getLoansByOngoing',
      'getLoanAvailableTime',
    ]),
    ...mapActions('evaluation', ['addCreditEvaluations']),
    /**
     * 대출 신청
     */
    async request() {
      if (this.requestLoanLoading) return
      try {
        this.requestLoanLoading = true
        if (this.isExpire) {
          const { isConfirmed } = await this.$swal.basic.confirm({
            html: '신용 인증 유효기간이 만료되어,<br> 신용 인증 페이지로 이동합니다',
          })
          if (!isConfirmed) {
            return
          }
          await this.addCreditEvaluations({
            redirectPath: `${this.$route.path}?requestProcess=true`,
          })
          return
        }
        if (this.me.isLoanable !== true) {
          await this.$swal.basic.alert({
            html: '대출신청을 할 수 없습니다. 고객센터로 문의 주세요.',
          })
          return
        }

        await this.createLoan(this.offer)
        await this.getLoansByOngoing()
        await this.$router.replace(`/loan/${this.investingPullRevenue.uuid}/investing`)
      } finally {
        this.requestLoanLoading = false
      }
    },
  },
  components: { GetOffer: () => import('@/components/loan/GetOffer.vue') },
}
</script>
